import React from 'react';
import cx from 'classnames';
import './icons';

// mouseOver mouseOut

export default class Icon extends React.Component {
    defaultProps = {
        size : false,
        thin : false,
        filled : false,
        badge : false,
        onClick: () => {},
        showTooltipFor: false
    };

	constructor(props) {
    	super(props);
  	}
	
    render() {
        var { thin, filled, badge, size, icon, children, onClick, showTooltipFor } = this.props;

        var iconClasses = cx([
            'b3-icon',
            filled ? 'b3-icon-streamline-24px-filled-in' : 'b3-icon-streamline-24px',
            thin ? 'thin' : '',
            `sl-icon-${icon}`,
        ]);

        var spanStyles = {};
        if (size)
        {
            spanStyles.fontSize = `${size}px`;
        }

        var showIconBadge = false;
        var badgeClasses = "";

        if(badge) {
            showIconBadge = true;
            badgeClasses = cx(['b3-icon', 'badge', 'b3-icon-streamline-24px', `sl-icon-${badge}`]);
        }

        var tooltipProps = showTooltipFor ? {
            'data-tip': true,
            'data-for': showTooltipFor
        } : {};

        return (
    		<span {...tooltipProps} onClick={onClick} style={spanStyles} className={iconClasses}>
                { children }
                
                { showIconBadge && 
                    <span className={badgeClasses}></span>
                }
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./app/b3/icons/Icon.js